import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { TABLASCOMUNES_MAIN, TABLASCOMUNES_UNICO } from 'constants/codigosTransacciones'

import UnicoPage from './unico/lista'
import MainPage from './tablasComunes'

export default function AsientosContablesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${TABLASCOMUNES_MAIN}`} component={MainPage} />
        <Route path={`/${TABLASCOMUNES_UNICO}/:tipoTabla`} component={UnicoPage} />
      </Switch>
    </Suspense>
  )
}
